import React from 'react';
import './InfoPage.css';

function Press() {
  return (
    <div className="info-page">
      <div className="info-container">
        <h1>Imprensa e Mídia</h1>

        <section className="info-section">
          <h2>Nukki nas Notícias</h2>
          <p>Bem-vindo à nossa sala de imprensa. Aqui você encontrará as últimas notícias, comunicados de imprensa, kits de mídia e recursos sobre a Nukki.</p>
        </section>

        <section className="info-section">
          <h3>Últimas Notícias</h3>

          <div className="job-listing">
            <h4>Nukki Expande para 190 Países, Alcançando Novo Marco</h4>
            <div className="job-meta">1 de Novembro de 2024</div>
            <p>A Nukki anuncia expansão para 15 novos países, tornando possível para viajantes reservar acomodações únicas em praticamente todos os países do mundo. A expansão inclui opções de pagamento local aprimoradas e suporte ao cliente 24 horas por dia, 7 dias por semana em vários idiomas.</p>
          </div>

          <div className="job-listing">
            <h4>Apresentando Recursos de Segurança Aprimorados para Anfitriões e Hóspedes</h4>
            <div className="job-meta">15 de Outubro de 2024</div>
            <p>A Nukki lança novos recursos de confiança e segurança incluindo verificação de identidade aprimorada, ferramentas de avaliação de risco e suporte ao cliente melhorado para garantir a segurança de nossa comunidade global.</p>
          </div>

          <div className="job-listing">
            <h4>Anfitriões da Nukki Ganham Mais de R$ 50 Bilhões em 2024</h4>
            <div className="job-meta">30 de Setembro de 2024</div>
            <p>A plataforma celebra ganhos recordes para anfitriões em todo o mundo, com renda média de anfitriões aumentando 25% ano a ano. Novas ferramentas e recursos ajudam anfitriões a otimizar seus anúncios e maximizar receita.</p>
          </div>

          <div className="job-listing">
            <h4>Iniciativa de Sustentabilidade: Opções de Viagem Neutras em Carbono</h4>
            <div className="job-meta">1 de Setembro de 2024</div>
            <p>A Nukki lança programa de compensação de carbono permitindo que hóspedes tornem suas estadias neutras em carbono. Parceria com organizações ambientais apoia projetos de reflorestamento e energia renovável.</p>
          </div>
        </section>

        <section className="info-section">
          <h3>Destaques da Empresa</h3>
          <div className="stats-grid">
            <div className="stat-box">
              <span className="stat-number">10M+</span>
              <span className="stat-label">Anúncios Ativos</span>
            </div>
            <div className="stat-box">
              <span className="stat-number">190+</span>
              <span className="stat-label">Países</span>
            </div>
            <div className="stat-box">
              <span className="stat-number">500M+</span>
              <span className="stat-label">Chegadas de Hóspedes</span>
            </div>
            <div className="stat-box">
              <span className="stat-number">5M+</span>
              <span className="stat-label">Anfitriões Ativos</span>
            </div>
          </div>
        </section>

        <section className="info-section">
          <h3>Comunicados de Imprensa</h3>
          <ul>
            <li>Resultados Financeiros e Atualizações da Plataforma do T3 2024</li>
            <li>Nukki Anuncia Novos Recursos de Acessibilidade</li>
            <li>Parceria com Conselhos de Turismo Locais em Todo o Mundo</li>
            <li>Cobertura de Seguro de Proteção ao Anfitrião Aprimorada</li>
            <li>Novos Recursos do Aplicativo Mobile para iOS e Android</li>
            <li>Fundo Comunitário Nukki Alcança R$ 500M em Apoio</li>
          </ul>
        </section>

        <section className="info-section">
          <h3>Recursos de Mídia</h3>

          <div className="feature-box">
            <h4>📸 Ativos da Marca</h4>
            <p>Baixe nosso logotipo, diretrizes da marca, capturas de tela de produtos e outros ativos visuais para uso editorial.</p>
            <ul>
              <li>Logotipo Nukki (PNG, SVG, EPS)</li>
              <li>Paleta de Cores da Marca</li>
              <li>Diretrizes de Tipografia</li>
              <li>Capturas de Tela de Produtos</li>
              <li>Fotos de Executivos</li>
            </ul>
          </div>

          <div className="feature-box">
            <h4>📊 Ficha Técnica</h4>
            <p>Fatos e números principais sobre a Nukki:</p>
            <ul>
              <li>Visão geral e história da empresa</li>
              <li>Estatísticas e métricas da plataforma</li>
              <li>Presença global e alcance</li>
              <li>Dados de impacto econômico</li>
              <li>Informações sobre confiança e segurança</li>
            </ul>
          </div>

          <div className="feature-box">
            <h4>🎥 Conteúdo de Vídeo</h4>
            <p>Acesse nossa biblioteca de conteúdo em vídeo incluindo:</p>
            <ul>
              <li>Vídeos de visão geral da empresa</li>
              <li>Depoimentos de anfitriões e hóspedes</li>
              <li>Demonstrações de produtos</li>
              <li>Cobertura de eventos</li>
              <li>Histórias de impacto social</li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Equipe Executiva</h3>

          <div className="feature-box">
            <h4>Biografias da Liderança</h4>
            <p>Conheça a equipe que lidera a missão da Nukki de criar um mundo onde qualquer pessoa possa pertencer a qualquer lugar:</p>
            <ul>
              <li>Diretor Executivo</li>
              <li>Diretor de Tecnologia</li>
              <li>Diretor Financeiro</li>
              <li>Diretor de Produto</li>
              <li>Diretor de Marketing</li>
              <li>Diretor de Pessoas</li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Prêmios e Reconhecimento</h3>
          <ul>
            <li>Melhor Plataforma de Tecnologia de Viagens 2024</li>
            <li>Top 100 Empresas para Trabalhadores Remotos</li>
            <li>Prêmio de Inovação em Hospitalidade</li>
            <li>Melhor Atendimento ao Cliente na Indústria de Viagens</li>
            <li>Prêmio de Liderança em Sustentabilidade</li>
            <li>Melhor Aplicativo Mobile para Viagens</li>
          </ul>
        </section>

        <section className="info-section">
          <h3>Consultas de Mídia</h3>
          <p>Para consultas de imprensa, solicitações de entrevista ou perguntas da mídia, entre em contato com nossa equipe de comunicações:</p>

          <div className="feature-box">
            <h4>Contato de Imprensa</h4>
            <p><strong>E-mail:</strong> press@nukki.com</p>
            <p><strong>Telefone:</strong> +1 (555) 123-4567</p>
            <p><strong>Linha de Mídia:</strong> Disponível 24 horas por dia, 7 dias por semana para consultas urgentes</p>
          </div>

          <div className="feature-box">
            <h4>Contatos de Mídia Regionais</h4>
            <ul>
              <li><strong>América do Norte:</strong> pr-americas@nukki.com</li>
              <li><strong>Europa:</strong> pr-europe@nukki.com</li>
              <li><strong>Ásia-Pacífico:</strong> pr-apac@nukki.com</li>
              <li><strong>América Latina:</strong> pr-latam@nukki.com</li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Redes Sociais</h3>
          <p>Siga a Nukki nas redes sociais para as últimas atualizações:</p>
          <ul>
            <li><strong>Twitter:</strong> @nukki</li>
            <li><strong>Facebook:</strong> /nukki</li>
            <li><strong>Instagram:</strong> @nukki</li>
            <li><strong>LinkedIn:</strong> /company/nukki</li>
            <li><strong>YouTube:</strong> /nukki</li>
          </ul>
        </section>

        <section className="info-section">
          <h3>Blog e Sala de Notícias</h3>
          <p>Mantenha-se atualizado com nossos últimos anúncios, atualizações de produtos e histórias da comunidade em nosso blog oficial e sala de notícias.</p>
        </section>
      </div>
    </div>
  );
}

export default Press;
